import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  return (
    <>
      <Helmet>
        <title>Oops! Something Went Wrong</title>
        <meta
          name="description"
          content="An error occurred while processing your request. Please try again later or contact support if the issue persists."
        />
      </Helmet>

      <section
        className="error-page full-height"
        style={{
          marginTop: "8rem", // or any value you need
        }}
      >
        <div className="error-page__shape-1">
          <img src="images/shapes/404-shape-1.png" alt="" />
        </div>
        <div className="error-page__shape-2" />
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="error-page__inner">
                <div className="error-page__title-box">
                  <h2 className="error-page__title">404</h2>
                </div>
                <h3 className="error-page__tagline">
                  Oops! Page can’t be found.
                </h3>
                <p className="error-page__text">
                  The page you are looking for doesn't exist or has been moved.
                </p>
                <div className="error-page__btn-box">
                  <Link to="/" className="error-page__btn thm-btn">
                    Take me to Home
                    <span className="icon-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ErrorPage;
